import React, {ChangeEvent, ReactNode} from 'react';
import PropTypes from 'prop-types';
import {Field, FieldAttributes} from 'formik';
import TextareaAutosize, {TextareaAutosizeProps} from 'react-textarea-autosize';

interface DataItemTextareaInputProps extends TextareaAutosizeProps {
  label?: ReactNode,
  customContainerStyle?: string,
  customTextareaStyle?: string,
  customLabelStyle?: string,
  onChange?: TextareaAutosizeProps['onChange'],
}

export const DataItemTextareaInput = ({
                                        label = null,
                                        customContainerStyle = 'w-100',
                                        customTextareaStyle = 'custom-data-item-textarea',
                                        customLabelStyle = '',
                                        ...rest
                                      }: DataItemTextareaInputProps) => {
  return (
    <label className={`mb-0 ${customContainerStyle}`}>
      <div className={customLabelStyle}>{label}</div>
      <TextareaAutosize
        className={`form-control ${customTextareaStyle}`}
        {...rest}
      />
    </label>
  );
};

interface DataItemTextareaProps extends DataItemTextareaInputProps {
  fieldId: string,
}

export const DataItemTextarea = ({
                                   fieldId,
                                   onChange,
                                   label = null,
                                   customContainerStyle = 'w-100',
                                   customTextareaStyle = 'custom-data-item-textarea',
                                   customLabelStyle = '',
                                   ...rest
                                 }: DataItemTextareaProps) => {
  const handleInputChange = ({form, field}: FieldAttributes<any>) => (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (onChange) {
      const changedValue = onChange(e);
      form.setFieldValue(field.name, changedValue);
    } else {
      form.setFieldValue(field.name, value);
    }
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({form, field}: FieldAttributes<any>) => (
        <DataItemTextareaInput
          className={`form-control ${customTextareaStyle}`}
          onChange={handleInputChange({form, field})}
          {...field}
          {...rest}
        />
      )}
    </Field>
  );
};

DataItemTextarea.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  label: PropTypes.node
};

export default DataItemTextarea;
